import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import {
    domainName, processApi
} from "../../../utility/index";
import {
    downLoadCarTemplateFile,
    exportCarXLXS
} from '../../../api/config/modules/VehicleFiles';

export default {
    name: 'VehicleAnnualReview',
    components: {
        tree,
        iTable,
        IPagination
    },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                driverNum: '',
                name: '',
                driverExpiresType: '',
                driverExpiresTime: [],
            },
            StateList: [
                {
                    value: '',
                    label: this.$t('common.all')
                },
                {
                    value: '0',
                    label: this.$t('common.normal')
                },
                {
                    value: '1',
                    label: this.$t('common.nearTime')
                },
                {
                    value: '2',
                    label: this.$t('common.exceedTime')
                }
            ],
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [{
                prop: "driverNum",
                label: this.$t('common.driverNum'),
                align: "center",
                width: "220px"
            },
            {
                prop: "name",
                label: this.$t('common.driverName'),
                align: "center",
                width: "160px"
            },
            {
                prop: "orgName",
                label: this.$t('common.orgName'),
                align: "center",
                width: "260px"
            },
            {
                prop: "driverExpires",
                label: this.$t('DriverManagement.driverExpires'),
                align: "center",
                width: "200px",
                // render: (h, params) => {
                //     return h('span', params.row.driverExpires ? this.$formatDate(params.row.driverExpires) : '')
                // }
            },
            {
                prop: "driverExpiresType",
                label: this.$t('DriverManagement.driverExpiresType'),
                align: "center",
                // width: "160px",
                render: (h, params) => {
                    return h('el-tag', {
                        props: { type: params.row.driverExpiresType === null ? '' : params.row.driverExpiresType === 0 ? 'success' : params.row.driverExpiresType === 1 ? 'warning' : 'danger' }
                    }, params.row.driverExpiresType === null ? '' : params.row.driverExpiresType === 0 ? this.$t('common.normal') : params.row.driverExpiresType === 1 ? this.$t('common.nearTime') : this.$t('common.exceedTime'))
                }
            },
            {
                prop: "remarks",
                label: this.$t('common.remark'),
                align: "center",
                width: "280px"
            },
            {
                label: this.$t('common.btn.operate'),
                align: "center",
                width: "120px",
                fixed: "right",
                render: (h, params) => {
                    return h('el-button',
                        {
                            props: {
                                type: 'primary', icon: params.row.filePath === null ? '' : 'iconfont icontupian'
                            },
                            on: {
                                click: () => {
                                    this.dialogImgFormVisible = true
                                    this.imgUrl = params.row.filePath
                                }
                            }
                        })
                }
            },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [
                    // {
                    //     id: '1',
                    //     show: true,
                    //     icon: 'iconfont icontupian',
                    //     plain: true,
                    //     disabled: false,
                    //     method: (index, row) => {
                    //         this.dialogImgFormVisible = true
                    //         this.imgUrl = row.filePath
                    //     }
                    // }
                ],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,

            selected: [],
            disabled: '',
            formLabelWidth: '140px',
            dialogFormVisible: false,
            btnType: '',
            rules: {
                changeExpireDate: [
                    { required: true, message: this.$t('common.btn.choseDate'), trigger: 'change' },
                ],
                filePath: [
                    { required: true, message: this.$t('common.btn.uploadPicture'), trigger: 'blur' },
                ]
            },
            form: {
                driverNum: '',
                name: '',
                nowExpireDate: '',
                changeExpireDate: '',
                filePath: ''
            },
            processImg: processApi,
            FileList: [],
            imageUrl: '',

            dialogOperateFormVisible: false,
            operatesList: [],
            operatesHeight: '350px',
            allColumns: [
                {
                    prop: "driverNum",
                    label: this.$t('common.driverNum'),
                    align: "center",
                    width: "200px"
                },
                {
                    prop: "name",
                    label: this.$t('common.driverName'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "jurisdictionName",
                    label: this.$t('JurisdictionalManagement.jurisdictionName'),
                    align: "center",
                    width: "180px"
                },
                {
                    prop: "nowExpireDate",
                    label: this.$t('DriverManagement.nowExpireDate'),
                    align: "center",
                    width: "160px",
                    // render: (h, params) => {
                    //     return h('span', params.row.nowExpireDate ? this.$formatDate(params.row.nowExpireDate) : '')
                    // }
                },
                {
                    prop: "changeExpireDate",
                    label: this.$t('DriverManagement.changeExpireDate'),
                    align: "center",
                    width: "140px",
                    // render: (h, params) => {
                    //     return h('span', params.row.changeExpireDate ? this.$formatDate(params.row.changeExpireDate) : '')
                    // }
                },
                {
                    prop: "auditState",
                    label: this.$t('DriverManagement.auditState'),
                    align: "center",
                    width: "120px",
                    render: (h, params) => {
                        return h('el-tag', {
                            props: { type: params.row.auditState === null ? '' : params.row.auditState === 0 ? 'warning' : params.row.auditState === 1 ? 'success' : 'danger' }
                        }, params.row.auditState === null ? '' : params.row.auditState === 0 ? this.$t('VehicleManagement.unapproved') : params.row.auditState === 1 ? this.$t('VehicleManagement.passed') : this.$t('VehicleManagement.rejected'))
                    }
                },
                {
                    prop: "auditOpinion",
                    label: this.$t('DriverManagement.auditOpinion'),
                    align: "center",
                    width: "120px"
                },
            ],
            allOperates: {
                width: 100,
                fixed: "right",
                list: [
                ],
            },
            OperatesCurrentPage: 1,
            OperatesPageSize: 10,
            OperatesTotal: 1,

            dialogImgFormVisible: false,
            imgUrl: '',
            select: []
        }
    },
    created() {

    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            if (this.$route.params.driverExpirationId) {
                this.formInline.driverExpiresType = this.$route.params.driverExpirationId
            }
            this.getAllCar()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.getAllCar()
        },
        getAllCar() {
            let startTime = ''
            let endTime = ''
            if (this.formInline.driverExpiresTime) {
                if (this.formInline.driverExpiresTime.length > 0) {
                    startTime = this.formInline.driverExpiresTime[0]
                    endTime = this.formInline.driverExpiresTime[1]
                }
            }
            let param = {
                companyId: sessionStorage.getItem("companyId"),
                orgId: this.id,
                driverNum: this.formInline.driverNum,
                name: this.formInline.name,
                driverExpiresType: this.formInline.driverExpiresType,
                driverExpiresTimeStar: startTime,
                driverExpiresTimeEnd: endTime,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('DriverAnnualReview/GET_GETDRIVERANNUALAPPROVELIST', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        console.log(this.columns)
                        this.operates.list.map(item => {
                            console.log(item)
                            this.list.map(items => {
                                console.log(items)
                                if (items.filePath != null || items.filePath != "") {
                                    item.icon = "iconfont icontupian"
                                } else {
                                    item.icon = ""
                                }
                                return item
                            })


                        })
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.getAllCar()
        },
        onClear() {
            this.formInline = {
                driverNum: '',
                name: '',
                driverExpiresType: '',
                driverExpiresTime: [],
            }
            this.getAllCar()
        },

        carAnnualReview() {
            this.dialogFormVisible = true
            this.btnType = "carAnnualReview"
            this.$nextTick(() => {
                this.$refs.form.clearValidate()
                this.form.driverNum = this.selected[0].driverNum
                this.form.name = this.selected[0].name
                this.form.nowExpireDate = this.selected[0].driverExpires
                this.form.filePath = ''
                this.imageUrl = ''
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        driverNum: this.form.driverNum,
                        nowExpireDate: this.form.nowExpireDate,
                        changeExpireDate: this.form.changeExpireDate,
                        filePath: this.form.filePath,
                    }
                    console.log(param)
                    this.$store.dispatch('DriverAnnualReview/GET_SUBMITDRIVERAUDIT', param).then(res => {
                        if (res.data.code == 200) {
                            if (this.btnType == "carAnnualReview") {
                                this.$message.success(this.$t('DriverManagement.driverAnnualSuccess'))
                                this.dialogFormVisible = false;
                                this.getAllCar();
                                this.closeDia();
                            } else {
                                this.$message.success(this.$t('DriverManagement.driverAnnualSuccess'))
                                this.dialogFormVisible = false;
                                this.getOperateList();
                                this.closeDia();
                            }
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    }).catch(err => { })

                } else {
                    return false;
                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                driverNum: '',
                name: '',
                nowExpireDate: '',
                changeExpireDate: '',
                filePath: ''
            }
        },
        closeDia() {
            this.form = {
                driverNum: '',
                name: '',
                nowExpireDate: '',
                changeExpireDate: '',
                filePath: ''
            }
            this.dialogFormVisible = false;
        },
        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw);
            this.form.filePath = res[0]
        },
        handleRemove(file, fileList) { },

        reAnnualReview() {
            this.dialogFormVisible = true
            this.btnType = "reAnnualReview"
            this.imageUrl = ''
            this.$nextTick(() => {
                this.$refs.form.clearValidate()
                this.form.driverNum = this.selected[0].driverNum
                this.form.name = this.selected[0].name
                this.form.nowExpireDate = this.selected[0].driverExpires
            })
        },
        ApprovalProgress() {
            this.dialogOperateFormVisible = true
            this.getOperateList()
        },
        getOperateList() {
            let param = {
                auditType: 1,
                driverNum: this.selected[0].driverNum,
                pageNum: this.OperatesCurrentPage,
                pageSize: this.OperatesPageSize,
            }
            this.$store.dispatch('DriverAnnualReview/GET_GETDRIVERAPPROVEPROGRESSLIST', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.operatesList = res.data.data.list
                        this.$refs.OperatesPage.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        closeOperateDia() {
            this.dialogOperateFormVisible = false
        },
        changeOperatesSize(item) {
            this.OperatesPageSize = item.pageSize
            this.OperatesCurrentPage = item.pageNum
            this.getOperateList()
        },
        handleOperatesChange(val) {
            this.select = val
        },

        closeImgDia() {
            this.dialogImgFormVisible = false
        },

        downCar() {
            if (domainName) {
                let startTime = ''
                let endTime = ''
                if (this.formInline.driverExpiresTime) {
                    if (this.formInline.driverExpiresTime.length > 0) {
                        startTime = this.formInline.driverExpiresTime[0]
                        endTime = this.formInline.driverExpiresTime[1]
                    }
                }
                let companyId = sessionStorage.getItem("companyId")
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportDriverAnnualApproveList?orgId=${this.id}&companyId=${companyId}&driverNum=${this.formInline.driverNum}&name=${this.formInline.name}&driverExpiresType=${this.formInline.driverExpiresType}&driverExpiresTimeStar=${startTime}&driverExpiresTimeEnd=${endTime}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportDriverAnnualApproveList?orgId=${this.id}&companyId=${companyId}&driverNum=${this.formInline.driverNum}&name=${this.formInline.name}&driverExpiresType=${this.formInline.driverExpiresType}&driverExpiresTimeStar=${startTime}&driverExpiresTimeEnd=${endTime}`
                    location.href = url
                }
            }
        },

        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getAllCar();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}